import axios from "axios"
const HOST = process.env.REACT_APP_API_HOST

export const checkProxyFetch = async (dataInput) => {
    return new Promise(async (resolve) => {
        let data = {}
        try {
            data = await axios.post(HOST + "/api/v1/utils/check-proxy/", dataInput)
        } catch (err) {
            data = err
        }
        resolve(data)
    })
}